// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import Notifications from 'vue-notification'
import _ from 'lodash'
import VeeValidate, {Validator} from 'vee-validate'
import VeeValidateLocaleDe from 'vee-validate/dist/locale/de'
import VueMoment from 'vue-moment'
import VueI18n from 'vue-i18n'
import Vuetify from 'vuetify'
import moment from 'moment'
import 'vuetify/dist/vuetify.min.css'
import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'
import numeral from 'numeral'
import Datetime from 'vue-datetime'
import VueGoogleCharts from 'vue-google-charts'
import 'bootstrap/scss/bootstrap.scss'


// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import '@fortawesome/fontawesome-pro/css/all.min.css'

import PieTitlePlugin from '../src/common/highcharts/pie-title-plugin'

import UiHTTP from './common/mixins/http.mixin'

import App from './App'

import store from './store'

import router from './router'

numeral.register('locale', 'de', {
  delimiters: {
    thousands: ' ',
    decimal: ','
  },
  abbreviations: {
    thousand: "k",
    million: "m",
    billion: "b",
    trillion: "t"
  },
});
numeral.locale('de')

PieTitlePlugin(Highcharts)

Vue.prototype._ = _
Validator.localize('de', VeeValidateLocaleDe)
Vue.use(VeeValidate)

Vue.use(Vuex)

Vue.use(VueMoment)

Vue.use(VueI18n)

Vue.use(VueGoogleCharts)

Vue.use(HighchartsVue)

Vue.use(Notifications)

Vue.use(Datetime)

Vue.use(Vuetify, { theme: {
  primary: '#2B4A89',
  secondary: '#444444',
  accent: '#ff5c1b',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107'
},
  iconfont: 'fa5'
})

Vue.mixin(UiHTTP)

// eslint-disable-next-line consistent-return
Vue.filter('formatToDate', value => moment(String(value)).format('MM.DD.YYYY'));

// eslint-disable-next-line consistent-return
Vue.filter('formatToDateWithHour', value => moment(String(value)).format('MM.DD.YYYY hh:mm'));

const numberFormats = {
  'de-DE': {
    currency: {
      style: 'currency', currency: 'EUR'
    }
  },
}

const i18n = new VueI18n({
  locale: 'de-DE', // set locale
  numberFormats
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js